import moment from 'moment'
import 'moment/locale/fr-ca'
import 'moment/locale/en-ca'

import { LocaleName } from './language'
import { Schedule } from './Models/workshops'

// date-fns uses format strings that are incompatible with moment.js
// TODO: see if we can drop one or both.  Possibly replace with browser standard: 
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
export const DateFormats = {
	Moment: {
		Day: 'dddd',
		Date: 'LL',
		Time: 'LT',
		DateAndTime: 'llll',
	},
	DateFns: {
		Date: 'PP',
	}
}

export function setFormatLocale(locale: LocaleName) {
	moment.locale(locale)
}

function day(date: Date) {
	return moment(date).format(DateFormats.Moment.Day)
}

function date(date: Date) {
	return moment(date).format(DateFormats.Moment.Date)
}

function time(date: Date) {
	return moment(date).format(DateFormats.Moment.Time)
}

function scheduleInterval(schedule: Schedule) {
	let startDateAndTime = moment(schedule.StartDateAndTime).format(DateFormats.Moment.DateAndTime)
	let endTime = time(schedule.EndDateAndTime)

	return `${startDateAndTime} - ${endTime}`
}

function monthNameAndYear(date: Date) {
	return moment(date).format('MMMM YYYY')
}

export const dayName = (dayNumber: number) => moment.weekdays(dayNumber)

function phoneNumber(phoneNumber: string | number) {
	const phoneString = phoneNumber.toString()
	return `(${phoneString.slice(0,3)})${phoneString.slice(3,6)}-${phoneString.slice(6)}`
}

function friendlyDurationTo(targetDate: Date) {
	return moment(targetDate).fromNow(true)
}

export const format = {
	day, date, time, scheduleInterval, phoneNumber, monthNameAndYear, dayName, friendlyDurationTo
}

export default format